import { useAdminStockSymbols } from '_hooks/useAdminStockSymbols'
import useEscape from '_hooks/useEscape';
import { Spinner } from 'components/common/Spinner';
import { BubbleChart } from 'components/public/Stock/BubbleChart'
import React from 'react'

export const ChartOverlay: React.FunctionComponent<{ symbolId: number, onEscape: () => void }> = ({ symbolId, onEscape }) => {

  const { api, getById } = useAdminStockSymbols(undefined);

  useEscape(() => {
    onEscape()
  });

  const render = () => {
    if (api.apiState.isLoading) {
      return <Spinner minHeight={25} />
    }

    if (api.apiState.isLoaded) {
      const symbol = getById(symbolId);
      if (symbol) {
        return <div className="p-3 text-white"><BubbleChart stockSymbol={symbol.name} predictionTypes={[]} showPredictors={false} /></div>
      }
    }

    return <></>
  }

  return (
    <div className="admin-chart-overlay bg-black">
      {render()}
    </div>
  )
}
